module.exports = __webpack_public_path__ + "img/purple.feb55a86.png";